import { Component, EventEmitter, Input, Output } from "@angular/core";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { NavItem } from "@core/services/utils/menu.service";
import { TranslateModule } from "@ngx-translate/core";
import { ButtonIconComponent } from "@ui/controls/button-icon/button-icon.component";
import { IconDisplayComponent } from "@ui/ui-helpers/display-formats/icon-display/icon-display.component";

@Component({
  selector: "app-mobile-menu",
  templateUrl: "./mobile-menu.component.html",
  styleUrl: "./mobile-menu.component.scss",
  imports: [
    TranslateModule,
    ButtonIconComponent,
    IconDisplayComponent,
    RouterLink,
    RouterLinkActive,
  ],
})
export class MobileMenuComponent {
  @Input() public isOpen = false;
  @Input() public menuItems: NavItem[] = [];

  @Output() public closeMenu = new EventEmitter<void>();

  onClose(): void {
    this.closeMenu.emit();
  }

  getNavItemUrl(
    navItem: NavItem
  ): { params: string[]; queryParams?: Record<string, string> } | null {
    if (navItem.route) {
      const [path, query] = navItem.route.split("?");
      const params = path.split("/").filter((segment: string) => segment);

      const queryParams = query
        ? query.split("&").reduce((acc: Record<string, string>, param) => {
            const [key, value] = param.split("=");
            acc[key] = value;
            return acc;
          }, {})
        : undefined;

      return { params, queryParams };
    }
    return null;
  }
}
